import { Save } from 'lucide-react';
import { Check } from 'lucide-react';
import { Minus } from 'lucide-react';
import { Plus } from 'lucide-react';
import React, {useEffect, useState} from "react";

import ajax from "../../../../services/AxiosInterceptor";
import {Code, Modal, NumberInput} from "@mantine/core";
import {notifications} from "@mantine/notifications";
import env_config from "../../../../env_config";
import {Tableau_helper, typeDonnee} from "../../../../components/tableau/Tableau_helper";
import {AxiosResponse} from "axios";
import {PrixSMS} from "../../../../types/codes_promo";
import {useDisclosure} from "@mantine/hooks";
import {LoadingButton} from "../../../../components/loading_button/loading_button";
import {LoadingDiv} from "../../../../components/loading_div/loading_div";

export function PrixSMSAdmin() {

    const [SMS, setSMS] = useState<PrixSMS[] | null>(() => null);
    const [Tel, setTel] = useState<PrixSMS[] | null>(() => null);
    const [nbe_SMS_orgas, set_nbe_SMS_orgas] = useState(0);
    const [nbe_Tel_orgas, set_nbe_Tel_orgas] = useState(0);

    const [btn_loading, setBtn_loading] = useState(false);


    function handleEnregistrer() {

        setBtn_loading(true);
        ajax.put("/be/prixSMS", {
            "prixSMS": SMS,
            "prixTel": Tel,
        }).then((response: AxiosResponse<any, any>) => {
            notifications.show({
                // id: 'enregistre',
                withCloseButton: true,
                autoClose: env_config.notifications_duree_affichage,
                color: 'green',
                title: "Validé!",
                message: 'Les prix sont enregistrés',
                icon: <Check/>,
                // className: 'my-notification-class',
                loading: false,
            });
            setBtn_loading(false);
        }).catch(error => {
            setBtn_loading(false);
        });

    }

    useEffect(() => {
        ajax.get("/be/prixSMS").then(response => {
            setSMS(response.data.prixSMS)
            setTel(response.data.prixTel)
            set_nbe_SMS_orgas(response.data.nbe_SMS)
            set_nbe_Tel_orgas(response.data.nbe_Tel)
        }).catch(e => {
        })
    }, []);

    return (
        <>
            <div className={"en-ligne margintop"}>
                {SMS ? (
                    <>
                        <h2>Au total sur la plateforme : </h2>
                        <div className="en-ligne">
                            <p className={"inline-tag green"}>
                                {nbe_SMS_orgas} SMS
                            </p>
                            <p className={"inline-tag green"}>
                                {nbe_Tel_orgas} Appels
                            </p>
                        </div>
                    </>
                ) : (
                   <LoadingDiv />
                )}

            </div>

            {SMS && (
                <>
                    <div className={"en-ligne spacebetween margintop"}>

                        <h2>Prix des SMS et Appels automatisés : </h2>

                        <LoadingButton style={{margin: "unset"}} is_loading={btn_loading}
                                       onClick={handleEnregistrer}><Save/> Enregistrer</LoadingButton>
                    </div>

                    <div className={"en-ligne margintop"}>
                        <button style={{margin: "unset"}} onClick={() => {
                            if (!SMS) return;
                            setSMS([...SMS, {
                                nbe: 0, prix: 0
                            }])
                        }}><Plus/></button>
                        <h3>SMS : </h3>
                    </div>
                    <table width="100%" className={"margintop"}>
                        <tr>
                            {/*<th>#</th>*/}
                            <th>Nombre</th>
                            <th>Prix HT</th>
                            <th>Supprimer</th>
                        </tr>
                        {SMS && SMS.map((ligne, index) => (

                            <tr>
                                {/*<td>#{index}</td>*/}
                                <td><NumberInput
                                    value={ligne.nbe}
                                    onChange={e => {
                                        setSMS(SMS.map((ligne_edit, i_edit) => {
                                            if (i_edit === index) {
                                                let _edit: PrixSMS = {...ligne_edit}
                                                _edit.nbe = Number(e)
                                                return _edit;
                                            }
                                            return ligne_edit;
                                        }))
                                    }}
                                /></td>
                                <td><NumberInput
                                    value={ligne.prix}
                                    onChange={e => {
                                        setSMS(SMS.map((ligne_edit, i_edit) => {
                                            if (i_edit === index) {
                                                let _edit: PrixSMS = {...ligne_edit}
                                                _edit.prix = Number(e)
                                                return _edit;
                                            }
                                            return ligne_edit;
                                        }))
                                    }}
                                /></td>
                                <td>
                                    <button onClick={() => {
                                        if (!SMS) return;
                                        setSMS(SMS.filter((s, i) => i !== index))
                                    }}><Minus/></button>
                                </td>
                            </tr>
                        ))}
                    </table>

                    <div className={"en-ligne margintop"}>
                        <button style={{margin: "unset"}} onClick={() => {
                            if (!Tel) return;
                            setTel([...Tel, {
                                nbe: 0, prix: 0
                            }])
                        }}><Plus/></button>
                        <h3>Appels automatisés : </h3>
                    </div>
                    <table width="100%" className={"margintop"}>
                        <tr>
                            {/*<th>#</th>*/}
                            <th>Nombre</th>
                            <th>Prix HT</th>
                            <th>Supprimer</th>
                        </tr>
                        {Tel && Tel.map((ligne, index) => (

                            <tr>
                                {/*<td>#{index}</td>*/}
                                <td><NumberInput
                                    value={ligne.nbe}
                                    onChange={e => {
                                        setTel(Tel.map((ligne_edit, i_edit) => {
                                            if (i_edit === index) {
                                                let _edit: PrixSMS = {...ligne_edit}
                                                _edit.nbe = Number(e)
                                                return _edit;
                                            }
                                            return ligne_edit;
                                        }))
                                    }}
                                /></td>
                                <td><NumberInput
                                    value={ligne.prix}
                                    onChange={e => {
                                        setTel(Tel.map((ligne_edit, i_edit) => {
                                            if (i_edit === index) {
                                                let _edit: PrixSMS = {...ligne_edit}
                                                _edit.prix = Number(e)
                                                return _edit;
                                            }
                                            return ligne_edit;
                                        }))
                                    }}
                                /></td>
                                <td>
                                    <button onClick={() => {
                                        if (!Tel) return;
                                        setTel(Tel.filter((s, i) => i !== index))
                                    }}><Minus/></button>
                                </td>
                            </tr>
                        ))}
                    </table>
                </>
            )}


        </>


    );
}
